export default (value) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }

  const reg = new RegExp('^([[A-Z0-9])+$', 'g').test(value);

  return reg;
};
